export default class Face {
  public constructor(
    public readonly top: boolean,
    public readonly side: boolean,
    public readonly bottom: boolean
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/Face.ts